import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableReferralFeedbackFragment = { readonly __typename?: 'SyncableReferralFeedback', readonly id: string, readonly referralId: string, readonly feedbackType: Types.ReferralFeedbackType, readonly patientId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncReferralFeedbackPullQueryVariables = Types.Exact<{
  input: Types.PullReferralFeedbackInput;
}>;


export type SyncReferralFeedbackPullQuery = { readonly __typename?: 'Query', readonly pullReferralFeedback: { readonly __typename?: 'PullReferralFeedbackResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableReferralFeedback', readonly id: string, readonly referralId: string, readonly feedbackType: Types.ReferralFeedbackType, readonly patientId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncReferralFeedbackPushMutationVariables = Types.Exact<{
  input: Types.PushReferralFeedbackInput;
}>;


export type SyncReferralFeedbackPushMutation = { readonly __typename?: 'Mutation', readonly pushReferralFeedback: { readonly __typename?: 'PushReferralFeedbackResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableReferralFeedback', readonly id: string, readonly referralId: string, readonly feedbackType: Types.ReferralFeedbackType, readonly patientId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableReferralFeedbackFragmentDoc = gql`
    fragment WholeSyncableReferralFeedback on SyncableReferralFeedback {
  id
  referralId
  feedbackType
  patientId
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncReferralFeedbackPullDocument = gql`
    query SyncReferralFeedbackPull($input: PullReferralFeedbackInput!) {
  pullReferralFeedback(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableReferralFeedback
    }
  }
}
    ${WholeSyncableReferralFeedbackFragmentDoc}`;

/**
 * __useSyncReferralFeedbackPullQuery__
 *
 * To run a query within a React component, call `useSyncReferralFeedbackPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncReferralFeedbackPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncReferralFeedbackPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncReferralFeedbackPullQuery(baseOptions: Apollo.QueryHookOptions<SyncReferralFeedbackPullQuery, SyncReferralFeedbackPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncReferralFeedbackPullQuery, SyncReferralFeedbackPullQueryVariables>(SyncReferralFeedbackPullDocument, options);
      }
export function useSyncReferralFeedbackPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncReferralFeedbackPullQuery, SyncReferralFeedbackPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncReferralFeedbackPullQuery, SyncReferralFeedbackPullQueryVariables>(SyncReferralFeedbackPullDocument, options);
        }
export type SyncReferralFeedbackPullQueryHookResult = ReturnType<typeof useSyncReferralFeedbackPullQuery>;
export type SyncReferralFeedbackPullLazyQueryHookResult = ReturnType<typeof useSyncReferralFeedbackPullLazyQuery>;
export type SyncReferralFeedbackPullQueryResult = Apollo.QueryResult<SyncReferralFeedbackPullQuery, SyncReferralFeedbackPullQueryVariables>;
export const SyncReferralFeedbackPushDocument = gql`
    mutation SyncReferralFeedbackPush($input: PushReferralFeedbackInput!) {
  pushReferralFeedback(input: $input) {
    rows {
      ...WholeSyncableReferralFeedback
    }
  }
}
    ${WholeSyncableReferralFeedbackFragmentDoc}`;
export type SyncReferralFeedbackPushMutationFn = Apollo.MutationFunction<SyncReferralFeedbackPushMutation, SyncReferralFeedbackPushMutationVariables>;

/**
 * __useSyncReferralFeedbackPushMutation__
 *
 * To run a mutation, you first call `useSyncReferralFeedbackPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncReferralFeedbackPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncReferralFeedbackPushMutation, { data, loading, error }] = useSyncReferralFeedbackPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncReferralFeedbackPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncReferralFeedbackPushMutation, SyncReferralFeedbackPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncReferralFeedbackPushMutation, SyncReferralFeedbackPushMutationVariables>(SyncReferralFeedbackPushDocument, options);
      }
export type SyncReferralFeedbackPushMutationHookResult = ReturnType<typeof useSyncReferralFeedbackPushMutation>;
export type SyncReferralFeedbackPushMutationResult = Apollo.MutationResult<SyncReferralFeedbackPushMutation>;
export type SyncReferralFeedbackPushMutationOptions = Apollo.BaseMutationOptions<SyncReferralFeedbackPushMutation, SyncReferralFeedbackPushMutationVariables>;